import { createFeatureSelector, createSelector } from '@ngrx/store';
import { workforceSolutionsFeatureKey } from './workforce-solutions.reducer';
import { WorkforceSolutionsState } from './state/workforce-solutions.state';

export const selectWorkforceSolutionsState =
    createFeatureSelector<WorkforceSolutionsState>(workforceSolutionsFeatureKey);

export const selectAccountManagerLookups = createSelector(
    selectWorkforceSolutionsState,
    (state) => state?.accountManagers
);

export const selectVMSProviderLookups = createSelector(selectWorkforceSolutionsState, (state) => state?.vmsProviders);

export const selectContractedGroupLookups = createSelector(
    selectWorkforceSolutionsState,
    (state) => state?.contractedGroups
);

export const selectBrandsLookups = createSelector(selectWorkforceSolutionsState, (state) => state?.brands);

export const selectBizDevManagersLookups = createSelector(
    selectWorkforceSolutionsState,
    (state) => state?.bizDevManagers
);

export const selectMSPManagersLookups = createSelector(selectWorkforceSolutionsState, (state) => state?.mspManagers);

export const selectHospitalSystemsHierarchyLookups = createSelector(
    selectWorkforceSolutionsState,
    (state) => state?.hospitalSystemsHierarchy
);

export const selectHospitalSystemsLookups = createSelector(
    selectWorkforceSolutionsState,
    (state) => state?.hospitalSystems
);

export const selectFacilityTypesLookups = createSelector(
    selectWorkforceSolutionsState,
    (state) => state?.facilityTypes
);

export const selectStatesLookups = createSelector(selectWorkforceSolutionsState, (state) => state?.states);
